// PageShell — common layout for detail/edit/add subroutes.
// Wraps content in a scroll area, with an optional sticky footer for
// action buttons (Save/Cancel/Delete). Matches the modal footer pattern.

import React from 'react'

interface PageShellProps {
  children: React.ReactNode
  /** Sticky bottom action bar (Save, Cancel, Delete, etc.). */
  footer?: React.ReactNode
}

export const PageShell: React.FC<PageShellProps> = ({children, footer}) => (
  <div className="flex min-h-0 flex-1 flex-col bg-background">
    <div className="min-h-0 flex-1 overflow-y-auto px-xl py-xl">{children}</div>
    {footer && (
      <div className="flex shrink-0 items-center justify-end gap-md border-t border-divider bg-surface px-xl py-md">
        {footer}
      </div>
    )}
  </div>
)
